export const countriesValueToBeShownOnTop = ["JP"];

export let cancelParamSplitterStr = "DAS###";

export const apmKeys = [ "hasGooglePay", "hasApplePay", "hasPayPay", "hasPayNow", "hasQRPH"]
export const apmKeyApplePayKey = "hasApplePay";
export const apmKeyPayNowKey = "hasPayNow";
export const apmKeyQrphKey = "hasQRPH";

export const cardinalEnabledAcquirer: string[] = ["cybersource","WORLDPAY"];